import { SearchableDropdown } from './SearchableDropdown';

interface HotelDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function HotelDropdown({
  value,
  onChange,
  placeholder = 'Select Hotel',
  className,
}: HotelDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search hotels..."
      className={className}
      endpoint="hotels"
      emptyText="No hotels found."
    />
  );
}
